import { AccessDenied } from '~publish/components/AccessDenied'

import type { JSX } from 'react'

/**
 * Full-page Access Restricted state for the All Channels Publish views (list
 * and calendar), shown when the actor has publishing access to none of the
 * organization's channels (@see areAllChannelsRestrictedForPublish).
 *
 * Rendered instead of the page, and deliberately without a CTA: the only way
 * forward is asking the organization owner for access.
 */
export const AllChannelsAccessDenied = (): JSX.Element => {
  return (
    <AccessDenied description="You don't have publishing access to any channels in this organization. Reach out to your organization owner to request access." />
  )
}
